import { CourseHearingReviewStatus } from '@new/features/courses/utils/hearingHelpers';
import { FC } from 'react';

interface HearingStatusMessageProps {
  status: CourseHearingReviewStatus;
}

export const HearingStatusMessage: FC<HearingStatusMessageProps> = ({ status }) => {
  if (status === 'approved') {
    return (
      <div className="flex w-full rounded-xl bg-(--success-S200) px-5 py-4">
        <p className="m-0! [font-size:var(--fs-p3)]! font-medium text-(--success-S700)">
          Congratulations! You successfully completed this course.
        </p>
      </div>
    );
  }

  if (status === 'notYet') {
    return (
      <div className="flex w-full rounded-xl bg-(--danger-D200) px-5 py-4">
        <p className="m-0! [font-size:var(--fs-p3)]! font-medium text-(--danger-D700)">
          You have not yet passed your course hearing. Review the course materials and arrange
          another meeting with your instructor when you're ready to try again.{' '}
        </p>
      </div>
    );
  }

  return null;
};
